import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';
import appConfig from '../config/app.config';

export type sidebarButtons = 'products' | 'modifiers' | 'none' | undefined;

interface sidebarState {
  open: boolean;
  currentlyShowing: sidebarButtons;
}

function initFromUrl(): sidebarButtons {
  const startUrl = window.location.href;
  if (startUrl.startsWith(`${appConfig.FE_URL}/products`)) {
    return 'products';
  } else if (startUrl.startsWith(`${appConfig.FE_URL}/modifiers`)) {
    return 'modifiers';
  } else {
    return 'products';
  }
}

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState: {
    open: true,
    currentlyShowing: initFromUrl()
  } as sidebarState,
  reducers: {
    changeCurrentlyShowing(state: sidebarState, action: PayloadAction<sidebarButtons>) {
      state.currentlyShowing = action.payload;
    }
  }
});

export const sidebarActions = sidebarSlice.actions;
export const currentButton = (state: RootState) => state.sidebar.currentlyShowing;

export default sidebarSlice;
  